"use strict";

// source: spine/ui/language.proto

/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
var jspb = require('google-protobuf');

var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../spine/options_pb.js');

goog.object.extend(proto, spine_options_pb);
goog.exportSymbol('proto.spine.ui.Language', null, global);
/**
 * @enum {number}
 */

proto.spine.ui.Language = {
  UNDEFINED: 0,
  AB: 1,
  AA: 2,
  AF: 3,
  AK: 4,
  SQ: 5,
  AM: 6,
  AR: 7,
  AN: 8,
  HY: 9,
  AS: 10,
  AV: 11,
  AE: 12,
  AY: 13,
  AZ: 14,
  BM: 15,
  BA: 16,
  EU: 17,
  BE: 18,
  BN: 19,
  BH: 20,
  BI: 21,
  BS: 22,
  BR: 23,
  BG: 24,
  MY: 25,
  CA: 26,
  KM: 27,
  CH: 28,
  CE: 29,
  NY: 30,
  ZH: 31,
  CU: 32,
  CV: 33,
  KW: 34,
  CO: 35,
  CR: 36,
  HR: 37,
  CS: 38,
  DA: 39,
  DV: 40,
  NL: 41,
  DZ: 42,
  EN: 43,
  EO: 44,
  ET: 45,
  EE: 46,
  FO: 47,
  FJ: 48,
  FI: 49,
  FR: 50,
  FF: 51,
  GD: 52,
  GL: 53,
  LG: 54,
  KA: 55,
  DE: 56,
  EL: 57,
  GN: 58,
  GU: 59,
  HT: 60,
  HA: 61,
  HE: 62,
  HZ: 63,
  HI: 64,
  HO: 65,
  HU: 66,
  IS: 67,
  IO_: 68,
  IG: 69,
  ID: 70,
  IA: 71,
  IE: 72,
  IU: 73,
  IK: 74,
  GA: 75,
  IT: 76,
  JA: 77,
  JV: 78,
  KL: 79,
  KN: 80,
  KR: 81,
  KS: 82,
  KK: 83,
  KI: 84,
  RW: 85,
  KY: 86,
  KV: 87,
  KG: 88,
  KO: 89,
  KJ: 90,
  KU: 91,
  LO: 92,
  LA: 93,
  LV: 94,
  LI: 95,
  LN: 96,
  LT: 97,
  LU: 98,
  LB: 99,
  MK: 100,
  MG: 101,
  MS: 102,
  ML: 103,
  MT: 104,
  GV: 105,
  MI: 106,
  MR: 107,
  MH: 108,
  MN: 109,
  NA: 110,
  NV: 111,
  NG: 112,
  NE: 113,
  ND: 114,
  SE: 115,
  NO: 116,
  NB: 117,
  NN: 118,
  OC: 119,
  OJ: 120,
  OR: 121,
  OM: 122,
  OS: 123,
  PI: 124,
  PS: 125,
  FA: 126,
  PL: 127,
  PT: 128,
  PA: 129,
  QU: 130,
  RO: 131,
  RM: 132,
  RN: 133,
  RU: 134,
  SM: 135,
  SG: 136,
  SA: 137,
  SC: 138,
  SR: 139,
  SN: 140,
  II: 141,
  SD: 142,
  SI: 143,
  SK: 144,
  SL: 145,
  SO: 146,
  NR: 147,
  ST: 148,
  ES: 149,
  SU: 150,
  SW: 151,
  SS: 152,
  SV: 153,
  TL: 154,
  TY: 155,
  TG: 156,
  TA: 157,
  TT: 158,
  TE: 159,
  TH: 160,
  BO: 161,
  TI: 162,
  TO: 163,
  TS: 164,
  TN: 165,
  TR: 166,
  TK: 167,
  TW: 168,
  UG: 169,
  UK: 170,
  UR: 171,
  UZ: 172,
  VE: 173,
  VI: 174,
  VO: 175,
  WA: 176,
  CY: 177,
  FY: 178,
  WO: 179,
  XH: 180,
  YI: 181,
  YO: 182,
  ZA: 183,
  ZU: 184
};
goog.object.extend(exports, proto.spine.ui); // Generated by Spine ProtoJs Plugin

proto.spine.ui.Language.typeUrl = function () {
  return 'type.spine.io/spine.ui.Language';
};
//# sourceMappingURL=language_pb.js.map